/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TeamSearchResultDto = {
    id?: number;
    name?: string;
    gender?: TeamSearchResultDto.gender;
    ageCategory?: TeamSearchResultDto.ageCategory;
    tier?: string;
    teamType?: TeamSearchResultDto.teamType;
    teamSubtype?: TeamSearchResultDto.teamSubtype;
    yearOfBirth?: TeamSearchResultDto.yearOfBirth;
    sportsClubId?: number;
    sportsClubName?: string;
    voivodeship?: string;
    county?: string;
    isMatchRequested?: boolean;
    logoUrl?: string;
    scheduleId?: number;
    distanceKm?: number;
};
export namespace TeamSearchResultDto {
    export enum gender {
        FEMALE = 'FEMALE',
        MALE = 'MALE',
    }
    export enum ageCategory {
        JUNIOR_STARSZY = 'JUNIOR_STARSZY',
        JUNIOR_MLODSZY = 'JUNIOR_MLODSZY',
        TRAMPKARZ = 'TRAMPKARZ',
        MLODZIK = 'MLODZIK',
        ORLIK = 'ORLIK',
        ZAK = 'ZAK',
        SKRZAT = 'SKRZAT',
    }
    export enum teamType {
        SENIOR = 'SENIOR',
        YOUTH = 'YOUTH',
    }
    export enum teamSubtype {
        FIRST_TEAM = 'FIRST_TEAM',
        SECOND_TEAM = 'SECOND_TEAM',
        THIRD_TEAM = 'THIRD_TEAM',
    }
    export enum yearOfBirth {
        YEAR_2007 = 'YEAR_2007',
        YEAR_2008 = 'YEAR_2008',
        YEAR_2009 = 'YEAR_2009',
        YEAR_2010 = 'YEAR_2010',
        YEAR_2011 = 'YEAR_2011',
        YEAR_2012 = 'YEAR_2012',
        YEAR_2013 = 'YEAR_2013',
        YEAR_2014 = 'YEAR_2014',
        YEAR_2015 = 'YEAR_2015',
        YEAR_2016 = 'YEAR_2016',
        YEAR_2017 = 'YEAR_2017',
        YEAR_2018 = 'YEAR_2018',
        YEAR_2019 = 'YEAR_2019',
        YEAR_2020 = 'YEAR_2020',
    }
}

